import {
  Avatar,
  Box,
  Flex,
  HStack,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import React from "react";
import { FiLogOut } from "react-icons/fi";
import { RiMenuLine } from "react-icons/ri";
import { TuteriaLogo as Logo } from "../../_new_/assets";

export const ApplicationHeader: React.FC<{
  isLoggedIn?: boolean;
  profilePhoto?: string;
  onLogoutClick?: () => void;
}> = ({ onLogoutClick = () => { }, profilePhoto, ...rest }) => {
  return (
    <Box
      as="header"
      position="sticky"
      top={0}
      bg="white"
      boxSize="full"
      zIndex="sticky"
      {...rest}
    >
      <Box
        boxShadow="sm"
        borderBottomWidth="1px"
        borderColor="gray.200"
        width="full"
      >
        <Box maxW="1560px" mx="auto" px={{ base: "5", md: "16" }} bg="white">
          <HStack minW="100%" align="center" height="4rem" justifyContent="space-between">
            <Logo h={{ base: 6, md: 6 }} />
            <Flex flex={1} ml={6} justify="end" minWidth="140px">
              <LogoutMenu
                onLogoutClick={onLogoutClick}
                profilePhoto={profilePhoto}
              />
            </Flex>
          </HStack>
        </Box>
      </Box>
    </Box>
  );
};

interface LogoutMenuProps {
  onLogoutClick?: () => void;
  profilePhoto?: string;
}

export const LogoutMenu = (props: LogoutMenuProps) => {
  return (
    <Menu>
      <MenuButton
        px={3}
        py={2}
        bg="white"
        transition="all 0.2s"
        justifyContent="center"
        display="flex"
        borderRadius="40px"
        alignItems="center"
        borderColor="gray.200"
        shadow="fbShadow"
        borderWidth="1px"
        _hover={{ shadow: "md" }}
        _focus={{ bg: "white" }}
        _active={{ bg: "white" }}
      >
        <HStack>
          <Icon fontSize="md" as={RiMenuLine} />
          <Avatar size="xs" src={props.profilePhoto} />
        </HStack>
      </MenuButton>
      <MenuList zIndex="sticky" borderColor="neutral.500">
        <MenuItem icon={<FiLogOut />} onClick={props.onLogoutClick}>
          Log out
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
